import http from './axios';
import MyDoneServices from './mydone';

export default class MyTodoServices {
  private readonly todoHandleCount_api = '/v1/mytodo/todo-handle-count'; // 待经办总览
  private readonly todoReviewCount_api = '/v1/mytodo/todo-review-count'; // 待复核总览
  private readonly todoApproveCount_api = '/v1/approverecord/todo-count'; // 待审批总览
  private readonly todoHandlePage_api = '/v1/mytodo/todo-handle-page'; // 我的待经办预警列表查询
  private readonly todoReviewPage_api = '/v1/mytodo/todo-review-page'; // 我的待复核预警列表查询
  private readonly todoApprovePage_api = '/v1/approverecord/todo-page'; // 我的待审批预警列表查询
  private readonly processHandleAlert_api = '/v1/mytodo/process-handle-alert'; // 经办/忽略/转办预警
  private readonly processReviewAlert_api = '/v1/mytodo/process-review-alert'; // 驳回/忽略/复核预警
  private readonly processApprove_pass_api = '/v1/approverecord/approve-batch'; // 通过或驳回待审批任务
  private readonly processApprove_reject_api = '/v1/approverecord/reject-batch'; // 通过或驳回待审批任务

  constructor() {}

  // 待经办总览
  async getHandleCount(params?: object): Promise<any> {
    let res: any = await http.get(this.todoHandleCount_api, { params: params });
    return res.payload;
  }
  // 我的待经办预警列表查询
  async getHandlePage(params?: object): Promise<any> {
    let res: any = await http.get(this.todoHandlePage_api, { params: params });
    return res.payload;
  }
  // 经办/忽略/转办预警
  async processHandleAlert(params: any) {
    let res: any = await http.post(this.processHandleAlert_api, params);
    return res.header?.code == 200 ? true : false;
  }

  // 待复核总览
  async getReviewCount(params?: object): Promise<any> {
    let res: any = await http.get(this.todoReviewCount_api, { params: params });
    return res.payload;
  }
  // 我的待复核预警列表查询
  async getReviewPage(params?: object): Promise<any> {
    let res: any = await http.get(this.todoReviewPage_api, { params: params });
    return res.payload;
  }
  // 驳回/忽略/复核预警
  async processReviewAlert(params: any) {
    let res: any = await http.post(this.processReviewAlert_api, params);
    return res.header?.code == 200 ? true : false;
  }

  // 待审批总览
  async getApproveCount(params?: object): Promise<any> {
    let res: any = await http.get(this.todoApproveCount_api, { params: params });
    return res.payload;
  }
  // 我的待审批预警列表查询
  async getApprovePage(params?: object): Promise<any> {
    let res: any = await http.get(this.todoApprovePage_api, { params: params });
    return res.payload;
  }
  // 通过或驳回待审批任务
  async processApproveAlert(params: any, type: 'pass' | 'reject') {
    if (type === 'pass') {
      let res: any = await http.post(this.processApprove_pass_api, params);
      return res.header?.code == 200 ? true : false;
    } else {
      let res: any = await http.post(this.processApprove_reject_api, params);
      return res.header?.code == 200 ? true : false;
    }
  }

  async getInfo(alertCode: string) {
    let mydone = new MyDoneServices();
    return await mydone.getInfo(alertCode);
  }
}
